"use client";
import SvgCallFilled from "./call-filled.svg.js";
import SvgCallOutlined from "./call-outlined.svg.js";
import SvgCallRound from "./call-round.svg.js";
import SvgCallSharp from "./call-sharp.svg.js";
import SvgChatFilled from "./chat-filled.svg.js";
import SvgChatOutlined from "./chat-outlined.svg.js";
import SvgChatRound from "./chat-round.svg.js";
import SvgChatSharp from "./chat-sharp.svg.js";
const call = {
  filled: SvgCallFilled,
  outlined: SvgCallOutlined,
  round: SvgCallRound,
  sharp: SvgCallSharp
};
const chat = {
  filled: SvgChatFilled,
  outlined: SvgChatOutlined,
  round: SvgChatRound,
  sharp: SvgChatSharp
};
export {
  call,
  chat
};
